import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faCheck,
  faPen,
  faTrashCan,
  faXmark,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DevolucionReadingFilteredDtoProps } from "api/DTOs/DevolucionReadingFilteredDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

const DEVOLUCIONES_INGRESOS_COLUMNS = (
  t: TFunction,
  openEditModal: (id: string) => void,
  openDeleteModal: (rowData: DevolucionReadingFilteredDtoProps) => void
) => {
  const columns = [
    {
      key: "identificador",
      header: `${t("devoluciones.tab.headerNum")}`,
      field: "identificador",
      style: { width: "10%" },
      sortable: true,
      sortField: "Identificador",
    },
    {
      key: "fecha",
      header: `${t("devoluciones.tab.headerDate")}`,
      field: "fecha",
      body: ({ fecha }: DevolucionReadingFilteredDtoProps) =>
        fecha ? frontendDateFormat(new Date(fecha)) : "-",
      style: { width: "10%" },
      sortable: true,
      sortField: "Fecha",
    },
    {
      key: "razonSocial",
      header: `${t("devoluciones.tab.headerClient")}`,
      field: "razonSocial",
      style: { width: "25%" },
      sortable: true,
      sortField: "Empresa.RazonSocial",
    },
    {
      key: "descripcion",
      header: `${t("devoluciones.tab.headerDescription")}`,
      field: "descripcion",
      sortable: true,
      sortField: "Descripcion",
    },
    {
      key: "importe",
      header: `${t("devoluciones.tab.headerTax")}`,
      field: "importe",
      body: ({ importe }: DevolucionReadingFilteredDtoProps) =>
        importe ? frontendCurrency(importe) : "-",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      style: { width: "10%" },
      sortable: true,
      sortField: "Importe",
    },
    {
      key: "remesado",
      header: `${t("devoluciones.tab.headerRemittance")}`,
      field: "remesado",
      style: { width: "5%" },
      body: ({ remesado }: DevolucionReadingFilteredDtoProps) =>
        FontAwesomeIcon({
          icon: remesado ? faCheck : faXmark,
          className: `tw-pt-1 tw-size-5 ${
            remesado ? "tw-text-secondary" : "tw-text-primary-25"
          }`,
        }),
      alignCol: "center",
      bodyClassName: "!tw-text-center",
      sortable: true,
      sortField:
        "FlujosTesoreria.FirstOrDefault(f => f.RemesaId.HasValue).Remesa",
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end tw-items-center",
      alignCol: "right",
      body: (rowData: DevolucionReadingFilteredDtoProps) => {
        if (!rowData.id) return null

        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: `${t("devoluciones.tab.edit")}`,
                hasRedirect: true,
                action: () => {
                  openEditModal(rowData?.id ?? "")
                },
                icon: faPen,
              },
              {
                title: `${t("devoluciones.tab.delete")}`,
                hasRedirect: true,
                action: () => openDeleteModal(rowData),
                icon: faTrashCan,
                className: "!tw-text-danger",
              },
            ]}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}

export default DEVOLUCIONES_INGRESOS_COLUMNS
